import { Text, View } from "react-native";
import { GestureResponderEvent } from "react-native";
import PopOver from "./PopOver";
import Button from "./Button";
import { Size } from "./PopOver/types";

interface UnsavedChangesModalProps {
  mutationLoading: boolean;
  showUnsavedChangesModal: boolean;
  setShowUnsavedChangesModal: (show: boolean) => void;
  discardAndExit: (e: GestureResponderEvent) => void;
  handleSubmit: (e: any) => void;
  title?: string;
  message?: string;
  buttonLabel?: string;
  cancelButtonLabel?: string;
  size?: Size;
}

const UnsavedChangesModal = ({
  mutationLoading,
  showUnsavedChangesModal,
  setShowUnsavedChangesModal,
  discardAndExit,
  handleSubmit,
  title = "You have unsaved changes",
  message = "Save or discard your changes to continue.",
  buttonLabel = "Save",
  cancelButtonLabel = "Exit & Discard",
  size = "sm",
}: UnsavedChangesModalProps) => (
  <PopOver visible={showUnsavedChangesModal} onDismiss={() => setShowUnsavedChangesModal(false)} size={size}>
    <Text className="text-regular-normal font-700 text-ink-dark">{title}</Text>
    <Text className="text-regular-normal font-400 text-ink-dark mt-2">{message}</Text>
    <View className="flex-row justify-end mt-4">
      <Button onPress={discardAndExit} size="small">
        {cancelButtonLabel}
      </Button>
      <Button
        disabled={mutationLoading}
        loading={mutationLoading}
        onPress={handleSubmit}
        size="small"
        mode="secondary"
        className="ml-2"
      >
        {buttonLabel}
      </Button>
    </View>
  </PopOver>
);

export default UnsavedChangesModal;
